import { useState, useCallback } from 'react';
import { convertLatLonToAddress, formatAddressString } from '../utils/commonMethods';
import { BuildingInfo, ReverseGeocodeRequest } from '../interfaces/Address';

interface UseAddressConversionReturn {
    convertCoordinatesToAddress: (request: ReverseGeocodeRequest) => Promise<BuildingInfo | null>;
    formatAddress: (buildingInfo: BuildingInfo) => string;
    isLoading: boolean;
    error: string | null;
}

export const useAddressConversion = (): UseAddressConversionReturn => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const convertCoordinatesToAddress = useCallback(async (request: ReverseGeocodeRequest): Promise<BuildingInfo | null> => {
        setIsLoading(true);
        setError(null);

        try {
            const result = await convertLatLonToAddress(request);

            if (!result) {
                setError('Failed to convert coordinates to address');
                return null;
            }

            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
            setError(errorMessage);
            return null;
        } finally {
            setIsLoading(false);
        }
    }, []);

    const formatAddress = useCallback((buildingInfo: BuildingInfo): string => {
        return formatAddressString(buildingInfo);
    }, []);

    return {
        convertCoordinatesToAddress,
        formatAddress,
        isLoading,
        error,
    };
};
